import React from "react";
import Modal from '../Modal'
import LoaderButton from "../LoaderButton";
import { checkTranslation, translate } from "../../utils/useful";
import FormViewer from "../FormViewer";
import SwitchInput from "../inputs/SwitchInput";
import TopicView from "../views/messenger/sideBar/TopicView";
import StagesManager from "../StagesManager";


class ImportModalSecond extends React.Component {
    state = {
        files: [
            { icon: "/assets/icons/uploadmodal/filesingle.svg", title: "Table-1 Grid-View.cvs", size: "171B" },
            { icon: "/assets/icons/uploadmodal/filesingle.svg", title: "Table-1 Grid-View.cvs", size: "171B" },
            { icon: "/assets/icons/uploadmodal/filesingle.svg", title: "Table-1 Grid-View.cvs", size: "171B" },
            { icon: "/assets/icons/uploadmodal/filesingle.svg", title: "Table-1 Grid-View.cvs", size: "171B" },
            { icon: "/assets/icons/uploadmodal/filesingle.svg", title: "Table-1 Grid-View.cvs", size: "171B" },
            { icon: "/assets/icons/uploadmodal/filesingle.svg", title: "Table-1 Grid-View.cvs", size: "171B" },
            { icon: "/assets/icons/uploadmodal/filesingle.svg", title: "Table-1 Grid-View.cvs", size: "171B" },
            { icon: "/assets/icons/uploadmodal/filesingle.svg", title: "Table-1 Grid-View.cvs", size: "171B" },
            { icon: "/assets/icons/uploadmodal/filesingle.svg", title: "Table-1 Grid-View.cvs", size: "171B" },
            { icon: "/assets/icons/uploadmodal/filesingle.svg", title: "Table-1 Grid-View.cvs", size: "171B" },
            { icon: "/assets/icons/uploadmodal/filesingle.svg", title: "Table-1 Grid-View.cvs", size: "171B" },
            { icon: "/assets/icons/uploadmodal/filesingle.svg", title: "Table-1 Grid-View.cvs", size: "171B" },
            { icon: "/assets/icons/uploadmodal/filesingle.svg", title: "Table-1 Grid-View.cvs", size: "171B" },

        ],

        options: [

        ]
    }


    render() {
        let options = this.state.options
        return (


            <div className="w-100 h-100 br-10" style={{ backgroundColor: "white", }}>
                <div className="pt-3 flexcb px-3 pb-3" style={{ backgroundColor: "#f6f6f6", borderBottom: "1px solid #eee", borderLeft: "1px solid #eee" }}>
                    <p className="mrd-3" style={{ whiteSpace: "nowrap" }}>{translate('Selected Files')}</p>
                    <div className="flexc">
                        <button className="gray-btn px-3 py-2 br-5 mrd-4">
                            <p className="font-size-10" style={{ whiteSpace: "nowrap" }}>{translate('Delete All')}</p>
                        </button>
                        <button className="purple-btn px-3 py-2 br-5" onClick={() => this.props.changeStage("forth")}>
                            <p className="white font-size-10">{translate('Upload')}</p>
                        </button>
                    </div>
                </div>
                <div className="px-2 mx-2 py-2 h-100 sc-gray3" style={{ overflowY: "scroll" }}>
                    {this.state.files.map((prop, index) => {
                        return (
                            <div className="flexcb py-2">
                                <div className="flexc">
                                    <img className="flexcc" src={prop.icon} />
                                    <div className="mld-3">
                                        <p className="font-size-14 weight-300" style={{ color: "#333" }}>{checkTranslation(prop.title)}</p>
                                        <p className="font-size-10 weight-300" style={{ color: "#666" }}>{checkTranslation(prop.size)}</p>
                                    </div>
                                </div>
                                <button className="gray-to-color-hover">
                                    <img src="/assets/icons/uploadmodal/remove.svg" />
                                </button>
                            </div>
                        )
                    })}
                </div>
            </div>

        );

    }
}


export default ImportModalSecond;
